import type { CompletedIntegrationSyncStatus } from "./integration-sync-status";

export const STANDARD_INTEGRATION_NOTICE_MAP = {
  unknown_internal_error: "error",
  unknown_external_error: "error",
  miter_field_required: "error",
  miter_field_update_unsupported: "error",

  mismatched_resource_metadata: "warning",
  long_running_sync: "warning",
  conflicting_external_objects: "warning",
  daily_sync_rerun: "warning",
  ledger_entries_exclude_expenses: "warning",

  no_matching_external_entity_found: "skipped",
  external_entity_missing_correlation_field: "skipped",
  no_matching_miter_entity_found: "skipped",
} satisfies Record<string, CompletedIntegrationSyncStatus>;

export const INTEGRATION_SPECIFIC_NOTICE_MAP = {
  netsuite_employee_must_be_active: "error",
  netsuite_field_value_invalid: "error",
  netsuite_subsidiary_mismatch: "error",
  netsuite_subsidiary_mapping_required: "error",
  netsuite_location_required: "error",
  netsuite_location_mapping_required: "error",
  netsuite_default_subsidiary_required: "error",
  netsuite_entity_required: "error",
  netsuite_intercompany_first_line_subsidiary: "error",
  netsuite_orphaned_journal_entry: "error",
} satisfies Record<string, CompletedIntegrationSyncStatus>;

export const INTEGRATION_NOTICE_STATUS_MAP = {
  ...STANDARD_INTEGRATION_NOTICE_MAP,
  ...INTEGRATION_SPECIFIC_NOTICE_MAP,
} satisfies Record<string, CompletedIntegrationSyncStatus>;

export type StandardIntegrationNoticeType = keyof typeof STANDARD_INTEGRATION_NOTICE_MAP;
export type IntegrationSpecificNoticeType = keyof typeof INTEGRATION_SPECIFIC_NOTICE_MAP;
export type IntegrationFrameworkNoticeType = keyof typeof INTEGRATION_NOTICE_STATUS_MAP;
